import React from 'react'

import FacebookBusinessManagerMissingWarning from '../../../../../../../features/components/warnings/FacebookBusinessManagerMissingWarning'

const FacebookBusinessManagerMissingWarningStep = () => {
  return <FacebookBusinessManagerMissingWarning />
}

export default FacebookBusinessManagerMissingWarningStep
